/** @jsxImportSource @emotion/react */
import React from 'react';

interface PropsShape {
    styles?: object
    children: React.ReactNode
}

/**
 * Renders a  report section title.
 */
export default function SectionTitle(props: PropsShape) {
    const styles = {
        fontFamily: 'Manulife JH Sans',
        fontSize: '12pt',
        fontWeight: 600,
        ...props.styles
    };
    return <h2 css={styles}>{props.children}</h2>;
}
